import { Menu } from '@shared/components/Menu';
import { View } from '@shared/components/View';
import { CardExportSubmenu } from '@shared/scenes/cards/CardActionMenu/CardExportSubmenu';

interface Props {
  entityId: string;
}

export function ExternalCardActionMenu({ entityId }: Props) {
  return (
    <View>
      <Menu align="left">
        <Menu.IconButton testID="external-card-action-menu-button" />
        <Menu.Content testID="external-card-action-menu">
          <CardExportSubmenu entityId={entityId} />
        </Menu.Content>
      </Menu>
    </View>
  );
}
